// import * as NavigationService from '../../../Services/NavigationService';
/**
 * ADD_MEMBER_SUCCESS
 */
function* addMemberSuccess({ user }) {
  console.log('Success', user)
}

export default addMemberSuccess
